export const reportES = {
  SUBMIT: 'Subir Reporte',
  INFO: 'Envíanos un reporte con el error que has encontrado'
}
